/* PARWIN: Klaviyo popup vs Clarity shopping agent.
   Agent lives in a shadow DOM whose host is #ads-agent-host, so we hide/show the host.
   1) Hide the agent while a full Klaviyo popup is visible.
   2) Bring it back promptly (on Klaviyo's close event / close click) with a short fade-in.
   3) Suppress the popup once a shopper has added to cart this session. */
(function () {
  var HOST_SEL  = '#ads-agent-host';
  var POPUP_SEL = '[data-testid="modal-form-container"], [data-testid="FULLSCREEN"]';
  var isHidden = false, closedAt = 0, pending = false;

  function hosts()     { return document.querySelectorAll(HOST_SEL); }
  function atcDone()   { try { return sessionStorage.getItem('pp_atc_done') === '1'; } catch (e) { return false; } }
  function closePopup(){ var c = document.querySelector('.klaviyo-close-form'); if (c) c.click(); }

  function popupOpen() {
    var els = document.querySelectorAll(POPUP_SEL), i, el, r, s;
    for (i = 0; i < els.length; i++) {
      el = els[i]; r = el.getBoundingClientRect();
      if (r.width < 240 || r.height < 200) continue;
      s = getComputedStyle(el);
      if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity || '1') === 0) continue;
      return true;
    }
    return false;
  }

  function hideAgent() {
    if (isHidden) return; isHidden = true;
    hosts().forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }
  function showAgent() {
    if (!isHidden) return; isHidden = false;
    hosts().forEach(function (el) {
      el.style.setProperty('transition', 'opacity .25s ease');
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('pointer-events');
      el.style.setProperty('opacity', '0', 'important');
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        el.style.setProperty('opacity', '1', 'important');
      }); });
    });
  }

  function refresh() {
    pending = false;
    if (Date.now() - closedAt < 1200) { showAgent(); return; }
    if (popupOpen()) {
      if (atcDone()) { closePopup(); showAgent(); }
      else hideAgent();
    } else {
      showAgent();
    }
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(refresh); } }
  function onClose()  { closedAt = Date.now(); showAgent(); }

  window.addEventListener('klaviyoForms', function (e) {
    var t = e && e.detail && e.detail.type;
    if (t === 'open') schedule();
    else if (t === 'close' || t === 'redirectedToUrl' || t === 'submit') onClose();
  });

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.klaviyo-close-form')) onClose();
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.add-to-cart-button, button[name="add"], [data-pp-addcart]') : null;
    if (!b) return;
    try { sessionStorage.setItem('pp_atc_done', '1'); } catch (err) {}
    setTimeout(function () { closePopup(); schedule(); }, 0);
  }, true);

  function start() {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    refresh();
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
